






import { Component, Vue, Prop, Watch } from 'vue-property-decorator';

@Component
export default class Loader extends Vue {
	@Prop({ type: Boolean, required: true }) showLoader!: boolean;

	show = false;

	@Watch('showLoader', { immediate: true, deep: true })
	protected onShowLoaderChanged(val: boolean) {
		this.show = val;
	}
	
}
